const cacheTypes = {
  //从服务器端获取数据
  newData: 1,
  //从缓存中获取数据
  formCache: 2,
  //从服务器端获取数据并且覆盖当前缓存中的数据
  refreshCache: 3
}

const d2crudOptions = {
  border: true,
  stripe: true,
  size: "medium"
}

const birthData = [{
    code: '01',
    name: '1月'
  },
  {
    code: '02',
    name: '2月'
  },
  {
    code: '03',
    name: '3月'
  },
  {
    code: '04',
    name: '4月'
  },
  {
    code: '05',
    name: '5月'
  },
  {
    code: '06',
    name: '6月'
  },
  {
    code: '07',
    name: '7月'
  },
  {
    code: '08',
    name: '8月'
  },
  {
    code: '09',
    name: '9月'
  },
  {
    code: '10',
    name: '10月'
  },
  {
    code: '11',
    name: '11月'
  },
  {
    code: '12',
    name: '12月'
  }
]

const countryPhoneCodeData = [{
    code: '+86',
    name: '中国'
  },
  {
    code: '+852',
    name: '中国香港'
  },
  {
    code: '+65',
    name: '新加坡'
  },
  {
    code: '+81',
    name: '日本'
  },
  {
    code: '+1',
    name: '美国/加拿大'
  },
  {
    code: '+82',
    name: '韩国'
  },
  {
    code: '+66',
    name: '泰国'
  },
  {
    code: '+60',
    name: '马来西亚'
  },
  {
    code: '+62',
    name: '印度尼西亚'
  },
  {
    code: '+63',
    name: '菲律宾'
  },
  {
    code: '+84',
    name: '越南'
  },
  {
    code: '+95',
    name: '缅甸'
  },
  {
    code: '+855',
    name: '柬埔寨'
  },
  {
    code: '+856',
    name: '老挝'
  },
  {
    code: '+673',
    name: '文莱'
  },
  {
    code: '+91',
    name: '印度'
  },
  {
    code: '+92',
    name: '巴基斯坦'
  },
  {
    code: '+880',
    name: '孟加拉国'
  },
  {
    code: '+94',
    name: '斯里兰卡'
  },
  {
    code: '+977',
    name: '尼泊尔'
  },
  {
    code: '+975',
    name: '不丹'
  },
  {
    code: '+976',
    name: '蒙古'
  },
  {
    code: '+7',
    name: '俄罗斯'
  },
  {
    code: '+44',
    name: '英国'
  },
  {
    code: '+33',
    name: '法国'
  },
  {
    code: '+49',
    name: '德国'
  },
  {
    code: '+39',
    name: '意大利'
  },
  {
    code: '+34',
    name: '西班牙'
  },
  {
    code: '+31',
    name: '荷兰'
  },
  {
    code: '+32',
    name: '比利时'
  },
  {
    code: '+41',
    name: '瑞士'
  },
  {
    code: '+43',
    name: '奥地利'
  },
  {
    code: '+45',
    name: '丹麦'
  },
  {
    code: '+46',
    name: '瑞典'
  },
  {
    code: '+47',
    name: '挪威'
  },
  {
    code: '+358',
    name: '芬兰'
  },
  {
    code: '+48',
    name: '波兰'
  },
  {
    code: '+420',
    name: '捷克'
  },
  {
    code: '+36',
    name: '匈牙利'
  },
  {
    code: '+30',
    name: '希腊'
  },
  {
    code: '+351',
    name: '葡萄牙'
  },
  {
    code: '+353',
    name: '爱尔兰'
  },
  {
    code: '+90',
    name: '土耳其'
  },
  {
    code: '+972',
    name: '以色列'
  },
  {
    code: '+966',
    name: '沙特阿拉伯'
  },
  {
    code: '+971',
    name: '阿联酋'
  },
  {
    code: '+974',
    name: '卡塔尔'
  },
  {
    code: '+965',
    name: '科威特'
  },
  {
    code: '+968',
    name: '阿曼'
  },
  {
    code: '+20',
    name: '埃及'
  },
  {
    code: '+27',
    name: '南非'
  },
  {
    code: '+234',
    name: '尼日利亚'
  },
  {
    code: '+254',
    name: '肯尼亚'
  },
  {
    code: '+251',
    name: '埃塞俄比亚'
  },
  {
    code: '+212',
    name: '摩洛哥'
  },
  {
    code: '+216',
    name: '突尼斯'
  },
  {
    code: '+213',
    name: '阿尔及利亚'
  },
  {
    code: '+55',
    name: '巴西'
  },
  {
    code: '+54',
    name: '阿根廷'
  },
  {
    code: '+56',
    name: '智利'
  },
  {
    code: '+57',
    name: '哥伦比亚'
  },
  {
    code: '+51',
    name: '秘鲁'
  },
  {
    code: '+52',
    name: '墨西哥'
  },
  {
    code: '+58',
    name: '委内瑞拉'
  },
  {
    code: '+61',
    name: '澳大利亚'
  },
  {
    code: '+64',
    name: '新西兰'
  }
]

const recommend = [{
    code: 0,
    name: '有'
  },
  {
    code: 1,
    name: '无'
  },
]

const isTrue = [{
    code: 0,
    name: '是'
  },
  {
    code: 1,
    name: '否'
  }
]

const sex = [{
    code: 106002,
    name: '男'
  },
  {
    code: 106001,
    name: '女'
  }
]

const attribution = [{
    code: 1,
    name: '上海'
  },
  {
    code: 2,
    name: '深圳'
  },
  {
    code: 3,
    name: '广州'
  },
  {
    code: 4,
    name: '北京'
  },
  {
    code: 5,
    name: '长沙'
  },
  {
    code: 6,
    name: '合肥'
  }
]

const iconList = {
  0: "el-icon-question",
  1: "el-icon-success",
  2: "el-icon-error"
}

const confirmStyle = {
  confirmButtonText: "确定",
  cancelButtonText: "取消",
  type: "warning"
}

module.exports = {
  cacheTypes,
  birthData,
  countryPhoneCodeData,
  recommend,
  isTrue,
  d2crudOptions,
  sex,
  attribution,
  iconList,
  confirmStyle
}



// WEBPACK FOOTER //
// ./src/common/dictionary.js